import { useSelector, useDispatch } from "react-redux";
import React, {useState, useEffect} from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, Stack } from "@mui/material";
import Typography from '@mui/material/Typography';
import AlarmDashboard from "./AlarmDashboard";
import PropTypes from 'prop-types';
import AlarmLeftPane from './AlarmLeftPane';

function CustomTabPanel(props,{setRightPaneVisible,rightpanevisible}) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{borderRadius:"0px"}}
        >
            {value === index && (
                <Box sx={{ p: 0, borderRadius:"0px" }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function AlarmDataArea(props){
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    //const height = props.expanded ? 900 : 798;
     useEffect(() => {
        if (overviewstate) {
          setPagesize(295);
        } else {
          setPagesize(260);
        }
      }, [overviewstate]);

    const alarmpathstate = useSelector((state) => state.mainpagedata.alarmtreepathselected)
    const [pagesize, setPagesize] = useState(421) /*  */
    const [tabvalue, setTabvalue] = useState('Alert Data');
    const [pathselected, setPathselected] = useState([
        <Typography key="Dashboards" className="crumbs" style={{fontSize: '16px', fontWeight: 700}}>
            Alarm Configuration
        </Typography>
    ])
    const [mainpath, setMainpath] = useState([])
    var Maintablist = ['Alert Data']
    const [maintabs, setMaintabs] = useState(Maintablist)
    
   useEffect(() => {
            setPagesize(296)
    },[overviewstate])

    useEffect(()=>{
        if((alarmpathstate.length-1) == 0){
            setTabvalue('Alert Data')  
        }else{
            setTabvalue(alarmpathstate[alarmpathstate.length-1])
        }
        
    },[alarmpathstate])
    /*useEffect(() => {
        var newpath = []
        newpath.push(tabvalue)
        newpath.push(sectabvalue)
        dispatch(updatetabpath(newpath))
        
    },[sectabvalue,tabvalue])
    */

    const handletabchange = (event, newValue) => {

        //Modifying as breadcrumbs as per tab change
         
       /*
        var breadcrumbsoptionsarray = props.pathselected;
        var newpath = [];
        var lengthofpath = props.pathselected.length;
        breadcrumbsoptionsarray.map((pathproperties,index)=>{
            return(
                <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
                    {(index == 1)?newValue:pathproperties.props.children}
                </Typography>
            )
        })
        props.setPathselected(breadcrumbsoptionsarray);*/
       // dispatch(updatetabpath(newpath))  
        setTabvalue(newValue)
    }

    return(
            <Box sx={{ width: "88%",marginRight:0,/*backgroundColor: 'var(--secondary-background)', borderRadius: '0px 0px 8px 8px'*/}}>
                <div style={{display: 'flex', flexDirection: 'row',width: '98%'}}>
                    <Tabs
                        value={tabvalue}
                        onChange={handletabchange}
                        TabIndicatorProps={{ hidden: true }}
                        sx={{
                            '& .MuiTabs-indicator': {
                                display: 'none',
                                height: '0px',
                                borderRadius: '0px',
                                backgroundColor: 'var(--action-button-light)',
                                borderBottom: "1px solid var(--SecondaryBackground)"
                            },
                            '& .Mui-selected': {
                                color: 'var(--LK_BrandBlue_1) !important',
                                fontWeight: '700 !important',
                                backgroundColor:'var(--SecondaryBackground)',
                                borderTop: "1px solid var(--HighlightedText_Stroke)",
                                borderLeft: "1px solid var(--HighlightedText_Stroke)",
                                borderRight: "1px solid var(--HighlightedText_Stroke)",
                                borderBottom: "1px solid var(--SecondaryBackground)",
                            },
                            '& .MuiTab-root': {
                                padding: '8px 8px 6px 8px !important',
                                margin: '0px !important',
                                /*minWidth: '63px',*/
                            },
                            minHeight: '30px',
                            marginBottom:'-1px'
                        }}
                    >
                        {
                            maintabs.map((tab) => {
                                return(
                                    <Tab
                                        sx={{
                                            minHeight: '30px',
                                            height: '30px',
                                        }}
                                        style={{
                                                color: 'var(--GreyVariation_2)',
                                                fontFamily: 'Roboto',
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                lineHeight: '18.75px',
                                                textTransform: 'capitalize'
                                            }}
                                        value={tab}
                                        label={tab}
                                    >
                                        {tab}
                                    </Tab>
                                )
                            })
                        }
                        
                    </Tabs>     
                </div>
                <Box style={{display: 'flex', flexDirection: 'row', width:"99%",backgroundColor:"var(--SecondaryBackground)",marginRight:"0px" ,border: "1px solid var(--HighlightedText_Stroke)",height: `calc(100vh - ${pagesize}px)`}} >         
                        { tabvalue==="Alert Data" && <AlarmDashboard setCountAlarms={props.setCountAlarms} checkfilterlist={props.checkfilterlist} setCheckfilterlist={props.setCheckfilterlist}/> }
                                         
                </Box>    
            </Box>
    )
}